import styled from "styled-components";
import tw from "twin.macro";

import { Input } from "../Input";
import { ListItem, ListProps, List, ListItemProps } from "../List";
import { Menu, IMenu, MenuFooter, IMenuFooter } from "../Menu";

export const StyledMenu = styled(Menu)<IMenu>`
  ${tw`tw-relative`}
  ${tw`tw-overflow-hidden`}
`;

export const StyledMenuFooter = styled(MenuFooter)<IMenuFooter>`
  ${tw`tw-justify-center`}
`;

export const StyledStartMenuList = styled(List)<ListProps>`
  ${tw`tw-py-2`}
`;

export const StyledStartMenuListItem = styled(ListItem)<ListItemProps>`
  ${tw`tw-pr-3`}
`;

export const StyledStartMenuTitle = styled.div`
  ${tw`tw-flex-1`}
`;

export const StyledStartMenuNoResults = styled.div`
  ${tw`tw-py-0.5`}
  ${tw`tw-text-center`}
`;

export const StyledStartMenuDot = styled.span`
  border-radius: 50%;
  background-color: var(--color-primary);
  color: var(--page-paper-main);
  line-height: 15px;
  width: 15px;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
  margin-left: 4px;
`;

export const StyledInputSubmenu = styled.div`
  ${tw`tw-px-3 tw-pt-3 tw-pb-2`}
`;

export const StyledInputSubmenuFooter = styled(MenuFooter)<IMenuFooter>`
  ${tw`tw-justify-between tw-pt-3`}
  height: auto;
`;

export const StyledInput = styled(Input)`
  ${tw`tw-w-full tw-mb-5`}
`;

StyledMenu.displayName = "StyledMenu";
StyledMenuFooter.displayName = "StyledMenuFooter";
StyledStartMenuList.displayName = "StyledStartMenuList";
StyledStartMenuListItem.displayName = "StyledStartMenuListItem";
StyledStartMenuTitle.displayName = "StyledStartMenuTitle";
StyledStartMenuDot.displayName = "StyledStartMenuDot";
StyledStartMenuNoResults.displayName = "StyledStartMenuNoResults";
StyledInputSubmenu.displayName = "StyledInputSubmenu";
StyledInputSubmenuFooter.displayName = "StyledInputSubmenuFooter";
StyledInput.displayName = "StyledInput";
